export default __webpack_public_path__ + "static/media/horizontal_right_to_left_below.4ce25d29.PNG";